<template>
    <div>
        <van-tabs type="card" class="xmbody">
            <van-tab :title="$t('details.etitle')">
                <div class="zc_info">
                    <van-row class="zc_line">
                        <van-col span="8" class="zc_first">{{ $t('details.proname') }}</van-col>
                        <van-col span="16" class="zc_second">{{info.title}}</van-col>
                    </van-row>
                    <van-row class="zc_line">
                        <van-col span="8" class="zc_first">{{ $t('details.pronano') }}</van-col>
                        <van-col span="16" class="zc_second">{{info.noid}}</van-col>
                    </van-row>
                    <van-row class="zc_line">
                        <van-col span="8" class="zc_first">{{ $t('details.prorisk') }}</van-col>
                        <van-col span="16" class="zc_second">{{info.risk}}</van-col>
                    </van-row>
                    <van-row class="zc_line">
                        <van-col span="8" class="zc_first">{{ $t('details.protime') }}</van-col>
                        <van-col span="16" class="zc_second">{{info.create_time}}</van-col>
                    </van-row>
                    <van-row class="zc_line">
                        <van-col span="8" class="zc_first">{{ $t('details.proscale') }}</van-col>
                        <van-col span="16" class="zc_second">{{info.scale}}</van-col>
                    </van-row>
                    <van-row class="zc_line">
                        <van-col span="8" class="zc_first">{{ $t('details.start_threshold') }}</van-col>
                        <van-col span="16" class="zc_second">{{info.start_threshold}}</van-col>
                    </van-row>
                    <van-row class="zc_line">
                        <van-col span="8" class="zc_first">{{ $t('details.term') }}</van-col>
                        <van-col span="16" class="zc_second">{{info.term}}</van-col>
                    </van-row>
                    <van-row class="zc_line">
                        <van-col span="8" class="zc_first">{{ $t('details.is_repeat') }}</van-col>
                        <van-col span="16" class="zc_second">{{info.is_repeat}}</van-col>
                    </van-row>
                    <van-row class="zc_line">
                        <van-col span="8" class="zc_first">{{ $t('details.insurance') }}</van-col>
                        <van-col span="16" class="zc_second">{{info.insurance}}</van-col>
                    </van-row>
                </div>
            </van-tab>
            <van-tab :title="$t('details.dettitle')">
                <van-row>
                    <van-col span="24" class="xm_det">
                       {{info.content}}
                    </van-col>
                </van-row>
            </van-tab>
        </van-tabs>
        <van-popup
                v-model="show"
                closeable
                close-icon="close"
                position="bottom"
                :style="{ height: '30%' }"
        ><div class="btn_buy">


                        <van-cell-group class="input_money">
                            <van-field v-model="money" :label="$t('details.buyMoney')" :placeholder="$t('details.buyMsg')" />
                        </van-cell-group>
            <van-button type="primary" block class="btn" color="linear-gradient(to right, #ff6034, #ee0a24)" @click="combuy(info.id)">{{ $t('details.buy') }}</van-button>
        </div>
        </van-popup>
        <div class="buybtn"><van-button type="primary" block class="btn" color="linear-gradient(to right, #ff6034, #ee0a24)" @click="buy()">{{ $t('details.buy') }}</van-button></div>
    </div>
</template>

<script>
    import {getReq} from "../../utils/api";

    export default {
        name: "DetailBody",

        data(){
            return{
                show:false,
                money:0
            }
        },

        props:{
          info:{
              type:Object,
              required:true
          }
        },
        methods:{
            buy(id){

                this.show = true;
                this.money = this.info.start_threshold.replace(/元起购/,'');
            },
            combuy(id){
                if(id){
                    getReq('/getBuy',{
                        id,
                        money:this.money
                    }).then((res)=>{
                        if(res.code=="200"){
                            this.$toast.success(this.$t('details.buyok'));
                            this.$router.push('./')
                        }else{
                            this.$toast.fail(this.$t('details.buyfail'));
                            this.show = false;
                        }
                    })
                }else{
                    this.$toast.fail("ERROR!");
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .xmbody{

        margin: 0  auto;
        padding: 10px;
        background: white;
        .zc_info{
            margin: 10px auto;
            text-align: left;
            text-indent: 10px;
            border: 1px solid #eeeeee;
            border-radius: 8px;
            .zc_line{
                height: 35px;
                line-height: 35px;
                border-bottom: 1px solid #eee;
                .zc_first{
                    border-right: 1px solid #eee;

                }
                .zc_second{
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }
            }
        }
        .xm_det{
            margin: 10px auto;
            text-align: left;
        }


    }
    .btn_buy{
        margin: 30px 10px;
        .input_money{
            margin-bottom: 20px;
        }
    }
    .buybtn{
        height: 60px;
        background: white;
        margin: 0 auto 10px auto;
        .btn{
            width: 92%;
            margin: 0 auto;
        }
    }
</style>
